import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import {
  FiPlusCircle,
  FiChevronDown,
  FiChevronUp,
  FiCalendar,
  FiX,
} from "react-icons/fi";
import ImageUploadCard from "../components/ImageUploadCard";
import MultiSelectDropdown from "../components/MultiSelectDropdown";
import { useNavigate } from "react-router-dom";
import api, { BASE_URL } from "../../../src/api_interceptor/api";
import {
  getApiErrorMessage,
  getClientResponseErrorMessage,
} from "../../../src/api_interceptor/apiErrorUtils";
import Loader from "../../components/loader/Loader";
import GenericModal from "../components/GenericModal";
import { sanitizeInput, sanitizeBrandingName, sanitizeName, sanitizeEmail } from "../../components/CommonFunction/CommonFunction";

const BRANDING_DOMAIN =
  process.env.REACT_APP_BRANDING_DOMAIN || ".planetums.com";

const ClientForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const hasFetchedClient = useRef(false);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);
  const [userToRemoveIndex, setUserToRemoveIndex] = useState(null);
  /** Snapshot of saved PXP system users when edit form loaded (for deactivate on remove). */
  const [initialSystemUsers, setInitialSystemUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    description: "",
    type: "success", // success | error | warning
  });

  // useEffect(() => {
  //   setShowSaveModal(true);
  // }, []);

  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [isCurrencyOpen, setIsCurrencyOpen] = useState(false);
  const [isClientTypeOpen, setIsClientTypeOpen] = useState(false);
  const [isParentClientOpen, setIsParentClientOpen] = useState(false);
  const [clientTypeMaster, setClientTypeMaster] = useState([]);
  const [enterpriseList, setEnterpriseList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [countryMaster, setCountryMaster] = useState([]);
  const [timeZoneMaster, setTimeZoneMaster] = useState([]);
  const [currencyMaster, setCurrencyMaster] = useState([]);
  const [systemRoleMaster, setSystemRoleMaster] = useState([]);
  const [standardRoleMaster, setStandardRoleMaster] = useState([]);
  const [customRoleMaster, setCustomRoleMaster] = useState([]);
  const [userTypeMaster, setUserTypeMaster] = useState([]);
  const [openUserTypeIndex, setOpenUserTypeIndex] = useState(null); // Track which user's dropdown is open
  const userTypeDropdownRefs = useRef({}); // Refs for each user type dropdown button
  const hasFetched = useRef(false);
  const hasInitialized = useRef(false);
  const [loginBgImage, setLoginBgImage] = useState(null);
  const [loginBgImageFile, setLoginBgImageFile] = useState(null); // For new file uploads
  const [companyLogoFile, setCompanyLogoFile] = useState(null);
  const [companyLogoFileObj, setCompanyLogoFileObj] = useState(null); // For new file uploads
  const [brandingUrl, setBrandingUrl] = useState("");

  const countries = ["India", "United States", "United Kingdom", "Germany"];
  const systemRoleOptions = [
    "Super Admin (Active)",
    "Admin (Active)",
    "Manager (Active)",
    "Viewer (Inactive)",
  ];

  const standardRoleOptions = [
    "Client Admin (Active)",
    "Read Only Viewer (Inactive)",
    "Support User (Active)",
  ];

  const customRoleOptions = [
    "EVS Supervisor (Active)",
    "Custom Role 1",
    "Custom Role 2",
  ];

  const [systemUsers, setSystemUsers] = useState([
    {
      id: 0,
      firstName: "",
      lastName: "",
      emailId: "",
      role: "",
      UserTypeId: "",
      DefaultRoleId: 0,
      active: true,
    },
  ]);

  // const [formData, setFormData] = useState({
  //   name: "",
  //   description: "",
  //   address: "",
  //   systemRoles: ["Super Admin (Active)"],
  //   standardRoles: ["Read Only Viewer (Inactive)"],
  //   customRoles: [],
  // });

  const [loginImage, setLoginImage] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [successModalOpen, setSuccessModalOpen] = useState(false);

  const [systemUserErrors, setSystemUserErrors] = useState([]);

  const [errors, setErrors] = useState({});
  const MAX_LOGO_SIZE = 2 * 1024 * 1024; // 2 MB for Company Logo
  const MAX_LOGIN_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB for Login Page Image
  const ALLOWED_SYSTEM_USER_DOMAIN = "@planetngtech.com";
  const SITE_CLIENT_TYPE_ID = 2;

  const isSiteClientType = (clientTypeId = formData.clientTypeId) =>
    Number(clientTypeId) === SITE_CLIENT_TYPE_ID;

  const [formData, setFormData] = useState({
    id: "",
    code: "",
    name: "",
    description: "",
    address: "",
    clientTypeId: "",
    clientTypeName: "",
    parentCompanyId: "",
    parentCompanyName: "",
    country: "",
    countryId: "",
    timeZoneId: "",
    timeZoneName: "",
    currencyCode: "",
    pocName: "",
    pocEmail: "",
    pocMobile: "",

    urlBrandingName: "",
    loginPageImage: null,
    companyLogo: null,

    numberOfLicenses: "",
    licenseInUse: 0,
    startDate: "",
    endDate: "",

    maxUserSessions: 2,
    sessionTimeout: 20,

    systemRoleIds: [],
    standardRoleIds: [],
    customRoleIds: [],
  });
  const [isTimeZoneOpen, setIsTimeZoneOpen] = useState(false);

  // useEffect(() => {
  //   if (isEditMode) {
  //     fetchClientById(id);
  //   }
  // }, [id]);

  // useEffect(() => {
  //   if (isEditMode) {
  //     editClient(id);
  //   }
  // }, [id]);

  useEffect(() => {
  getRoles();
}, []);
  const companyId = localStorage.getItem("companyId");

const getRoles = () => {
  api.post("api/GetAllUserRoleDetailsByCompanyId", {
    CompanyId: companyId
  })
  .then((response) => {
    if (response.data) {
      setRoles(response.data);
    }
  })
  .catch((error) => {
    console.error("Error fetching roles:", error);
  });
};

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    getDropdownList();
  }, []);

  useEffect(() => {
    if (!isEditMode) return;
    if (hasFetchedClient.current) return;

    // Wait for dropdown data to load before editing
    // Use a timeout to ensure dropdowns are loaded
    const timer = setTimeout(() => {
      if (hasFetchedClient.current) return;
      hasFetchedClient.current = true;
      editClient(id);
    }, 500); // Wait 500ms for dropdowns to load

    return () => clearTimeout(timer);
  }, [id, isEditMode, systemRoleMaster.length]);

  // useEffect(() => {
  //   if (!isEditMode) return;
  //   if (hasInitialized.current) return;

  //   hasInitialized.current = true;

  //   (async () => {
  //     try {
  //       setIsLoading(true);
  //       await getDropdownList();
  //       await editClient(id);
  //     } catch (err) {
  //       console.error("Initialization failed", err);
  //     }
  //   })();
  // }, [id, isEditMode]);

  const fetchClientById = async (clientId) => {
    const response = {
      name: "GlobalTech Solutions",
      description: "International client",
      address: "Bangalore, India",
      country: "India",
      pocName: "Alice Johnson",
      pocEmail: "alice.johnson@example.com",
      pocMobileNumber: "+91-9876543210",
      urlBrandingName: "globaltech",
      licenseInUse: 75,
      numberOfLicenses: 150,
      startDate: "2024-01-01",
      endDate: "2024-12-31",
      firstName: "Alice",
      lastName: "Johnson",
      emailId: "alice.johnson@example.com",
      role: "Administrator",
      systemRoles: "Admin",
      standardRoles: "User",
      customRoles: "CustomRole1",
    };

    setFormData(response);
  };
  const validateImageFile = (file, errorKey) => {
    if (!file) return true;

    // Use different size limits based on image type
    const maxSize =
      errorKey === "loginImage" ? MAX_LOGIN_IMAGE_SIZE : MAX_LOGO_SIZE;
    const maxSizeMB = errorKey === "loginImage" ? 5 : 2;

    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        [errorKey]: `Image size should not exceed ${maxSizeMB} MB`,
      }));
      return false;
    }

    return true;
  };

  useEffect(() => {
    const closeDropdown = () => {
      setIsCountryOpen(false);
      setIsCurrencyOpen(false);
      setOpenUserTypeIndex(null);
    };
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  // Update dropdown position on scroll/resize when dropdown is open
  useEffect(() => {
    if (openUserTypeIndex === null) return;

    const updateDropdownPosition = () => {
      // Force re-render to update dropdown position
      // The dropdown will recalculate position using getBoundingClientRect
      setOpenUserTypeIndex((prev) => prev); // Trigger re-render
    };

    window.addEventListener("scroll", updateDropdownPosition, true);
    window.addEventListener("resize", updateDropdownPosition);

    return () => {
      window.removeEventListener("scroll", updateDropdownPosition, true);
      window.removeEventListener("resize", updateDropdownPosition);
    };
  }, [openUserTypeIndex]);

  const handleAddUser = () => {
    setSystemUsers((prev) => [
      ...prev,
      {
        id: 0,
        firstName: "",
        lastName: "",
        emailId: "",
        role: "",
        UserTypeId: "",
        active: true,
      },
    ]);
  };

  const handleRemoveUserClick = (index) => {
    // Only allow removal if more than 1 user exists
    if (systemUsers.length > 1) {
      setUserToRemoveIndex(index);
      setShowRemoveUserModal(true);
    }
  };

  const confirmRemoveUser = () => {
    if (userToRemoveIndex !== null && systemUsers.length > 1) {
      setSystemUsers((prev) => prev.filter((_, i) => i !== userToRemoveIndex));
      // Clear errors for removed user
      setSystemUserErrors((prev) =>
        prev.filter((_, i) => i !== userToRemoveIndex),
      );
      setShowRemoveUserModal(false);
      setUserToRemoveIndex(null);
    }
  };

  const showSuccess = (message) => {
    setModalState({
      open: true,
      title: "Success",
      description: message,
      type: "success",
    });
  };

  const showError = (message) => {
    setModalState({
      open: true,
      title: "Error",
      description: message || "Something went wrong. Please try again.",
      type: "error",
    });
  };

  const showWarning = (message) => {
    setModalState({
      open: true,
      title: "Warning",
      description: message,
      type: "warning",
    });
  };

  //   const SubmitForm = () => {
  //   const payload = {
  //     ...formData,
  //     systemUsers,
  //   };

  //   console.log("Submitting payload:", payload);

  //   submitClient();
  // };

  const SubmitForm = () => {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const payload = {
      ...formData,
      systemUsers,
    };

    submitClient(payload);
  };

  const validateForm = () => {
    const newErrors = {};
    const userErrors = [];

    if (!formData.name?.trim()) newErrors.name = "Client name is mandatory";

    if (!formData.clientTypeId) {
      newErrors.clientType = "Client type is mandatory";
    }

    if (isSiteClientType() && !formData.parentCompanyId) {
      newErrors.parentClient = "Parent client is mandatory for Site";
    }

    if (!formData.address?.trim())
      newErrors.address = "Office address is mandatory";
    if (!formData.country) newErrors.country = "Select country is mandatory";
    if (!formData.countryId) newErrors.country = "Select country is mandatory";

    if (!formData.timeZoneId && !formData.timeZoneName?.trim()) {
      newErrors.timeZone = "Select timezone is mandatory";
    }

    // Currency is mandatory for Enterprise only; Sites inherit from parent Enterprise.
    if (!isSiteClientType() && !formData.currencyCode?.trim()) {
      newErrors.currency = "Select currency is mandatory";
    }

    if (!formData.pocName?.trim()) newErrors.pocName = "POC name is mandatory";

    if (!formData.pocEmail?.trim()) {
      newErrors.pocEmail = "POC email is mandatory";
    } else if (
      !/^(?!.*\.\.)(?!.*@@)[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.pocEmail)
    ) {
      newErrors.pocEmail = "Enter a valid email address";
    }

    if (!formData.pocMobile?.trim()) {
      newErrors.pocMobile = "POC mobile number is mandatory";
    }
    // Check login page image: either new file uploaded OR existing image exists (edit mode)
    if (loginBgImageFile && loginBgImageFile instanceof File) {
      // New file uploaded - validate size
      if (loginBgImageFile.size > MAX_LOGIN_IMAGE_SIZE) {
        newErrors.loginImage = "Image size should not exceed 5 MB";
      }
    } else if (!loginBgImage) {
      // No new file AND no existing image - require upload
      newErrors.loginImage = "Please upload login page image";
    }

    // Check company logo: either new file uploaded OR existing logo exists (edit mode)
    if (companyLogoFileObj && companyLogoFileObj instanceof File) {
      // New file uploaded - validate size
      if (companyLogoFileObj.size > MAX_LOGO_SIZE) {
        newErrors.companyLogo = "Image size should not exceed 2 MB";
      }
    } else if (!companyLogoFile) {
      // No new file AND no existing logo - require upload
      newErrors.companyLogo = "Please upload company logo";
    }

    if (!formData.numberOfLicenses) {
      newErrors.numberOfLicenses = "Add number is mandatory";
    } else if (formData.numberOfLicenses <= 0) {
      newErrors.numberOfLicenses = "Number of licenses must be greater than 0";
    }

    if (
      formData.maxUserSessions === "" ||
      formData.maxUserSessions === null ||
      formData.maxUserSessions === undefined
    ) {
      newErrors.maxUserSessions = "Number of sessions allowed per user is mandatory";
    } else if (Number(formData.maxUserSessions) <= 0) {
      newErrors.maxUserSessions = "Number of sessions must be between 1 and 99";
    } else if (Number(formData.maxUserSessions) > 99) {
      newErrors.maxUserSessions = "Number of sessions must be between 1 and 99";
    }

    if (
      formData.sessionTimeout === "" ||
      formData.sessionTimeout === null ||
      formData.sessionTimeout === undefined
    ) {
      newErrors.sessionTimeout = "Session timeout is mandatory";
    } else if (![20, 30, 60, 120, 0].includes(Number(formData.sessionTimeout))) {
      newErrors.sessionTimeout = "Select a valid session timeout";
    }

    if (!formData.startDate) newErrors.startDate = "Start date is mandatory";
    if (!formData.endDate) {
      newErrors.endDate = "End date is mandatory";
    } else if (new Date(formData.endDate) < new Date(formData.startDate)) {
      newErrors.endDate = "End date must be after start date";
    }

    if (!formData.urlBrandingName?.trim()) {
      newErrors.urlBrandingName = "URL branding name is mandatory";
    } else if (!/^[a-zA-Z0-9_-]+$/.test(formData.urlBrandingName)) {
      newErrors.urlBrandingName =
        "URL branding name must be alphanumeric (letters, numbers, hyphens, underscores)";
    }

    const totalRoles =
      (formData.systemRoleIds || []).length +
      (formData.standardRoleIds || []).length +
      (formData.customRoleIds || []).length;
    if (totalRoles < 1) {
      newErrors.roleMapping = "At least one role must be selected (System, Standard, or Custom).";
    }

    // if (!loginImage) newErrors.loginImage = "Image is mandatory!";
    // if (!companyLogo) newErrors.companyLogo = "Image is mandatory!";

    systemUsers.forEach((user, index) => {
      const rowError = {};

      if (!user.firstName?.trim())
        rowError.firstName = "First name is mandatory";
      if (!user.lastName?.trim()) rowError.lastName = "Last name is mandatory";

      if (!user.emailId?.trim()) {
        rowError.emailId = "Email id is mandatory";
      } else if (
        !/^(?!.*\.\.)(?!.*@@)[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.emailId)
      ) {
        rowError.emailId = "Enter a valid email address";
      } else if (
        !user.emailId
          .trim()
          .toLowerCase()
          .endsWith(ALLOWED_SYSTEM_USER_DOMAIN)
      ) {
        rowError.emailId = `Email must be under ${ALLOWED_SYSTEM_USER_DOMAIN} domain`;
      } else {
        const normalizedEmail = user.emailId.trim().toLowerCase();
        const duplicateIndex = systemUsers.findIndex(
          (other, otherIndex) =>
            otherIndex !== index &&
            other.emailId?.trim().toLowerCase() === normalizedEmail,
        );
        if (duplicateIndex !== -1) {
          rowError.emailId = "User with this email already exists.";
        }
      }

      // Role validation: require both a selected role name and DefaultRoleId
      if (!user.role?.trim() || !user.DefaultRoleId) {
        rowError.role = "Role is mandatory";
      }

      userErrors[index] = rowError;
    });

    setErrors(newErrors);
    setSystemUserErrors(userErrors);

    const hasFormErrors = Object.keys(newErrors).length > 0;
    const hasUserErrors = userErrors.some((err) => Object.keys(err).length > 0);

    return !hasFormErrors && !hasUserErrors;
  };

  const checkBrandingUrl = async (url) => {
    if (!url || !url.trim()) return true; // Skip if empty, validation will catch it

    try {
      const API_URL = "api/CheckBrandingUrl";
      const req_body = {
        BrandingUrl: url,
      };

      const response = await api.post(API_URL, req_body, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      // API returns CMSStatusCode: Success=0, AlreadyExists=2, Exception=3, Invalid=5
      if (response?.data === 0) {
        return true; // URL is available
      } else if (response?.data === 2) {
        showError(
          "Branding URL already exists. Please choose a different URL.",
        );
        return false;
      } else if (response?.data === 5) {
        showError(
          "URL branding name must be alphanumeric (letters, numbers, hyphens, underscores).",
        );
        return false;
      } else {
        showError("Error checking branding URL. Please try again.");
        return false;
      }
    } catch (error) {
      console.error("Branding URL check error:", error);
      // Don't block submission if check fails, but log it
      return true;
    }
  };

  const submitClient = async () => {
    setIsLoading(true);
    setSaving(true);

    // Check branding URL first (only for new clients or if URL changed)
    if (!isEditMode || brandingUrl !== formData.urlBrandingName) {
      const urlAvailable = await checkBrandingUrl(formData.urlBrandingName);
      if (!urlAvailable) {
        setIsLoading(false);
        setSaving(false);
        return;
      }
    }

    const API_URL = "api/AddOrEditClient";

    // Map kept/new system users (active) — ID from GetEdit (existing) or 0 (new user)
    const activeUserList = systemUsers.map((user) => ({
      ID: user.id ?? user.ID ?? 0,
      FirstName: user.firstName,
      LastName: user.lastName,
      EmailId: user.emailId,
      // UserTypeId is optional in UI; backend accepts null
      UserTypeId: user.UserTypeId || null,
      DefaultRoleId: user.DefaultRoleId ?? user.RoleId ?? 0,
      ClientTypeId: Number(formData.clientTypeId) || 0,
      ParentCompanyId: formData.parentCompanyId || null,
      IsActive: true,
    }));

    // Saved users removed from Section 4 must be deactivated in PXP on save
    const remainingIds = new Set(
      systemUsers
        .map((u) => u.id ?? u.ID ?? 0)
        .filter((id) => id > 0),
    );
    const removedUserList = initialSystemUsers
      .filter((u) => {
        const id = u.id ?? u.ID ?? 0;
        return id > 0 && !remainingIds.has(id);
      })
      .map((user) => ({
        ID: user.id ?? user.ID ?? 0,
        FirstName: user.firstName || "",
        LastName: user.lastName || "",
        EmailId: user.emailId || "",
        UserTypeId: user.UserTypeId || null,
        DefaultRoleId: user.DefaultRoleId ?? user.RoleId ?? 0,
        ClientTypeId: Number(formData.clientTypeId) || 0,
        ParentCompanyId: formData.parentCompanyId || null,
        IsActive: false,
      }));

    const userList = [...activeUserList, ...removedUserList];

    const req_body = {
      Id: isEditMode ? parseInt(formData.id) : 0,
      ClientName: formData.name,
      ClientDescription: formData.description || "",
      Address: formData.address,
      CountryId: formData.countryId,
      TimeZoneId: formData.timeZoneId || null,
      CurrencyCode: formData.currencyCode || null,
      POCName: formData.pocName,
      POCEmail: formData.pocEmail,
      POCMobile: formData.pocMobile,
      BrandingUrl: formData.urlBrandingName,
      NoofLicense: Number(formData.numberOfLicenses),
      LicenseStartDate: formData.startDate,
      LicenseEndDate: formData.endDate,
      MaxUserSessions: Number(formData.maxUserSessions),
      SessionTimeout: Number(formData.sessionTimeout),
      ClientTypeId: Number(formData.clientTypeId),
      ParentCompanyId: isSiteClientType()
        ? Number(formData.parentCompanyId)
        : null,
      userList: userList,
      systemRoleList: formData.systemRoleIds || [],
      standardRoleList: formData.standardRoleIds || [],
      customRoleList: formData.customRoleIds || [],
    };

    try {
      const response = await api.post(API_URL, req_body, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      if (response && response.data) {
        // Check StatusCode: 1 = Success, 0 = Error, 3 = Exception
        if (response.data.StatusCode === 1) {
          const companyId = response.data.CompanyId;

          // Upload files if company was created/updated successfully
          if (companyId) {
            try {
              await addFiles(companyId);
            } catch (fileError) {
              console.error("File upload error:", fileError);
              // Still show success for client creation, but warn about files
              showWarning(
                "Client saved successfully, but file upload failed. Please try uploading files again.",
              );
              setIsLoading(false);
              setSaving(false);
              setShowSaveModal(false);
              return;
            }
          }

          showSuccess(
            isEditMode
              ? "Client updated successfully."
              : "Client added successfully.",
          );
          setShowSaveModal(false);
        } else if (response.data.StatusCode === 0) {
          showError(
            getClientResponseErrorMessage(
              response.data,
              "Failed to save client. Please try again.",
            ),
          );
        } else if (response.data.StatusCode === 3) {
          const errorMsg =
            response.data.Message ||
            "An error occurred while saving client. Please try again.";
          showError(errorMsg);
        } else {
          showError("Invalid response from server. Please try again.");
        }
      } else {
        showError("Invalid response from server. Please try again.");
      }
    } catch (error) {
      console.error("Submit client error:", error);

      if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        showError(
          "Unable to connect to server. Please check your internet connection.",
        );
      } else if (error.response) {
        const isServerError = error.response.status >= 500;
        const errorMsg = isServerError
          ? "An error occurred while saving client. Please try again."
          : getApiErrorMessage(error, "Failed to save client. Please try again.");
        showError(errorMsg);
      } else {
        showError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
      setSaving(false);
      setShowSaveModal(false);
    }
  };

  const addFiles = async (companyId) => {
    const fileUploadData = new FormData();

    fileUploadData.append("CompanyId", companyId);
    fileUploadData.append("BrandingUrl", formData.urlBrandingName || "");

    // Only append files if they are File objects (new uploads)
    // If they are strings (URLs), they're already uploaded, skip them
    if (loginBgImageFile && loginBgImageFile instanceof File) {
      fileUploadData.append("LoginBGImage", loginBgImageFile);
    }

    if (companyLogoFileObj && companyLogoFileObj instanceof File) {
      fileUploadData.append("CompanyLogoFile", companyLogoFileObj);
    }

    // Nothing new to upload — treat as success
    if (
      !(loginBgImageFile instanceof File) &&
      !(companyLogoFileObj instanceof File)
    ) {
      return true;
    }

    const API_URL = "api/uploadClientFile";

    // Do NOT set Content-Type manually — browser must add multipart boundary
    const response = await api.post(API_URL, fileUploadData, {
      withCredentials: true,
    });

    // Check if upload was successful (returns 1 on success, 0 on error)
    if (response?.data === 1 || response?.data === true) {
      return true;
    }

    const detail =
      typeof response?.data === "object"
        ? response.data?.message || response.data?.Message || JSON.stringify(response.data)
        : String(response?.data);
    throw new Error(`File upload failed: ${detail}`);
  };

  // const getDropdownList = () => {

  //   const API_URL = "api/GetAllDetailsToAddclient";
  //   const req_body = {

  //   };

  //   api.post(API_URL, req_body, {
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     withCredentials: true
  //   })
  //     .then((response) => {

  //       if (response && response.data) {
  //             setCountryMaster(response.data.countryList);
  //             setTimeZoneMaster(response.data.timezoneList);
  //             setSystemRoleMaster(response.data.systemRoleList);
  //             setStandardRoleMaster(response.data.StandardRolList);
  //             setCustomRoleMaster(response.data.customeRoleList);
  //             setCountryMaster(response.data.countryList);

  //           setIsLoading(false);
  //       } else {
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //       console.error(error);
  //     });
  // };

  const getDropdownList = async () => {
    const API_URL = "api/GetAllDetailsToAddclient";
    const req_body = {};

    try {
      const response = await api.post(API_URL, req_body, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      if (response && response.data) {
        setCountryMaster(response.data.countryList || []);
        setTimeZoneMaster(response.data.timezoneList || []);
        setCurrencyMaster(
          response.data.currencyList || response.data.CurrencyList || [],
        );
        setSystemRoleMaster(response.data.systemRoleList || []);
        setStandardRoleMaster(response.data.StandardRolList || []);
        setCustomRoleMaster(response.data.customeRoleList || []);
        setUserTypeMaster(response.data.userTypeList || []);
        setClientTypeMaster(response.data.clientTypeList || []);
        setEnterpriseList(response.data.enterpriseList || []);

        // Add mode: default roles - System all checked, Standard all checked, Custom none
        if (!isEditMode) {
          const sysIds = (response.data.systemRoleList || []).map((r) => r.id);
          const stdIds = (response.data.StandardRolList || []).map((r) => r.id);
          setFormData((prev) => ({
            ...prev,
            systemRoleIds: sysIds,
            standardRoleIds: stdIds,
            customRoleIds: [],
          }));
        }

        return response.data; // ✅ IMPORTANT for chaining
      }
    } catch (error) {
      console.error(error);
      throw error; // ✅ allow caller to catch
    } finally {
      setIsLoading(false);
    }
  };

  const editClient = async (id) => {
    setIsLoading(true);
    const API_URL = "api/GetAllDetailsToEditClientForm";
    const req_body = {
      CompanyId: id,
    };

    try {
      const response = await api.post(API_URL, req_body, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      if (response && response.data) {
        // Check if API returned success
        if (response.data.Message === "Success" || response.data.Id) {
          BindEditClient(response.data);
        } else {
          showError(response.data.Message || "Failed to load client details.");
        }
      } else {
        showError("Invalid response from server. Please try again.");
      }
    } catch (error) {
      console.error("Edit client error:", error);

      if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        showError(
          "Unable to connect to server. Please check your internet connection.",
        );
      } else if (error.response) {
        const errorMsg =
          error.response.data?.Message ||
          "Failed to load client details. Please try again.";
        showError(errorMsg);
      } else {
        showError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const BindEditClient = (res) => {
    const data = res;
    const files = data.CompanyFiles;
    const typeOptions = data.clientTypeList || [];
    const parentOptions = data.enterpriseList || [];

    // Get branding URL from CompanyFiles (as per API structure)
    const brandingUrlFromAPI = files?.BrandingUrl || data.BrandingUrl || "";
    const selectedClientType = typeOptions.find(
      (ct) => Number(ct.id) === Number(data.ClientTypeId),
    );
    const selectedParent = parentOptions.find(
      (enterprise) => Number(enterprise.id) === Number(data.ParentCompanyId),
    );

    setFormData((prev) => ({
      ...prev,

      id: data.Id ?? "",
      clientCode: data.ClientCode ?? "",
      name: data.ClientName ?? "",
      description: data.ClientDescription ?? "",
      address: data.Address ?? "",
      clientTypeId: data.ClientTypeId ?? "",
      clientTypeName: selectedClientType?.name || "",
      parentCompanyId: data.ParentCompanyId ?? "",
      parentCompanyName: selectedParent?.name || "",
      country: data.CountryName ?? "",
      countryId: data.CountryId ?? "",
      timeZoneId: data.TimezoneId ?? data.TimeZoneId ?? "",
      timeZoneName: data.TimeZoneName ?? "",
      currencyCode: data.CurrencyCode ?? data.currencyCode ?? "",
      pocName: data.POCName ?? "",
      pocEmail: data.POCEmail ?? "",
      pocMobile: data.POCMobile ?? "",

      urlBrandingName: brandingUrlFromAPI,
      loginPageImage: files?.LoginBGImagePath ?? "",
      companyLogo: files?.CompanyLogoPath ?? "",

      numberOfLicenses: data.NoofLicense ?? "",
      licenseInUse: data.UsedLicense ?? 0,
      startDate: data.LicenseStartDate
        ? data.LicenseStartDate.split("T")[0]
        : "",
      endDate: data.LicenseEndDate ? data.LicenseEndDate.split("T")[0] : "",
      maxUserSessions: data.MaxUserSessions ?? data.maxUserSessions ?? 2,
      sessionTimeout: data.SessionTimeout ?? data.sessionTimeout ?? 20,

      // System: always all (all checked and disabled in UI)
      systemRoleIds: (systemRoleMaster.length ? systemRoleMaster.map((r) => r.id) : (data.systemRoleList || []).map((r) => r.id)),
      standardRoleIds: (data.StandardRolList || []).filter((r) => r.selected).map((r) => r.id),
      customRoleIds: (data.customeRoleList || []).filter((r) => r.selected).map((r) => r.id),
    }));

    // Set image previews (these are URLs from server)
    if (files?.LoginBGImagePath) {
      setLoginBgImage(files.LoginBGImagePath);
      setLoginBgImageFile(null); // No new file, using existing
    }
    if (files?.CompanyLogoPath) {
      setCompanyLogoFile(files.CompanyLogoPath);
      setCompanyLogoFileObj(null); // No new file, using existing
    }

    // Set branding URL
    setBrandingUrl(brandingUrlFromAPI);

    if (Array.isArray(data.clientTypeList)) {
      setClientTypeMaster(data.clientTypeList);
    }
    if (Array.isArray(data.enterpriseList)) {
      setEnterpriseList(data.enterpriseList);
    }
    const editCurrencyList = data.currencyList || data.CurrencyList;
    if (Array.isArray(editCurrencyList)) {
      setCurrencyMaster(editCurrencyList);
    }

    // Set user list from API response - API returns 'userList' (lowercase)
    const apiUserList = data.userList || data.UserList || [];

    if (Array.isArray(apiUserList) && apiUserList.length > 0) {
      // Map API user data to form user format
      const mappedUsers = apiUserList.map((user) => {
        // Map ID from GetEdit API (user.ID / user.Id) - existing users have ID, needed for update
        const userId = user.ID ?? user.Id ?? user.id ?? 0;

        return {
          id: userId,
          firstName: user.FirstName || "",
          lastName: user.LastName || "",
          emailId: user.EmailId || "",
          role: user.RoleName || "",
          UserTypeId: user.UserTypeId || "",
          DefaultRoleId: user.DefaultRoleId ?? 0,
          active: true,
        };
      });

      // Set users + snapshot for remove/deactivate tracking
      setSystemUsers(mappedUsers);
      setInitialSystemUsers(mappedUsers.map((u) => ({ ...u })));
    } else {
      // If no user list in response or empty array, keep default single empty user
      setSystemUsers([
        {
          id: 0,
          firstName: "",
          lastName: "",
          emailId: "",
          role: "",
          UserTypeId: "",
          DefaultRoleId: 0,
          active: true,
        },
      ]);
      setInitialSystemUsers([]);
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <div className="bg-white rounded-lg p-6">
        <div className="mb-4">
          <h1 className="text-xl font-semibold leading-[1.3]">
            {isEditMode ? "Edit Client" : "Add Client"}
          </h1>

          <nav className="text-sm mb-3" aria-label="Breadcrumb">
            <span
              className="cursor-pointer text-blue-500 hover:underline"
              onClick={() => navigate("/clients")}
            >
              Clients
            </span>

            <span className="mx-1 text-gray-400">&gt;</span>

            <span className="text-primary">
              {isEditMode ? formData.clientCode || "Edit Client" : "Add Client"}
            </span>
          </nav>
        </div>

        <div className="overflow-y-auto max-h-[calc(100vh-16rem)] pl-1 pr-6 custom-scrollbar">
          <div className="mb-7">
            <h2 className="text-base font-semibold text-primary mb-4">
              Section 1: Basic Details
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Keep Client Type (+ Parent) on their own row so Code always starts below Client Type */}
              <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <label className="block text-sm font-medium mb-1">
                    Client Type <span className="text-error">*</span>
                  </label>

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsClientTypeOpen((prev) => !prev);
                      setIsParentClientOpen(false);
                      setIsCountryOpen(false);
                      setIsTimeZoneOpen(false);
                      setIsCurrencyOpen(false);
                    }}
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                      errors.clientType ? "input-error" : ""
                    }`}
                  >
                    <span
                      className={
                        formData.clientTypeName ? "text-black" : "text-gray-400"
                      }
                    >
                      {formData.clientTypeName || "- Select -"}
                    </span>
                    {isClientTypeOpen ? (
                      <FiChevronUp size={16} />
                    ) : (
                      <FiChevronDown size={16} />
                    )}
                  </button>

                  {isClientTypeOpen && (
                    <div
                      className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] overflow-y-auto menu-scrollbar"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {clientTypeMaster.map((clientType) => (
                        <div
                          key={clientType.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            const isSite = Number(clientType.id) === SITE_CLIENT_TYPE_ID;
                            setFormData((prev) => ({
                              ...prev,
                              clientTypeId: clientType.id,
                              clientTypeName: clientType.name,
                              parentCompanyId: isSite ? prev.parentCompanyId : "",
                              parentCompanyName: isSite ? prev.parentCompanyName : "",
                              // Enterprise requires explicit selection; Site inherits from parent.
                              currencyCode: "",
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              clientType: null,
                              parentClient: isSite ? prev.parentClient : null,
                              currency: null,
                            }));
                            setIsClientTypeOpen(false);
                            setIsCurrencyOpen(false);
                            if (!isSite) {
                              setIsParentClientOpen(false);
                            }
                          }}
                          className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                        >
                          {clientType.name}
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="min-h-[16px]">
                    {errors.clientType && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.clientType}
                      </p>
                    )}
                  </div>
                </div>

                {isSiteClientType() && (
                  <div className="relative">
                    <label className="block text-sm font-medium mb-1">
                      Parent Name <span className="text-error">*</span>
                    </label>

                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsParentClientOpen((prev) => !prev);
                        setIsClientTypeOpen(false);
                        setIsCountryOpen(false);
                        setIsTimeZoneOpen(false);
                        setIsCurrencyOpen(false);
                      }}
                      className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                        errors.parentClient ? "input-error" : ""
                      }`}
                    >
                      <span
                        className={
                          formData.parentCompanyName ? "text-black" : "text-gray-400"
                        }
                      >
                        {formData.parentCompanyName || "- Select -"}
                      </span>
                      {isParentClientOpen ? (
                        <FiChevronUp size={16} />
                      ) : (
                        <FiChevronDown size={16} />
                      )}
                    </button>

                    {isParentClientOpen && (
                      <div
                        className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] overflow-y-auto menu-scrollbar"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {enterpriseList.length === 0 ? (
                          <div className="px-4 py-2.5 text-sm text-gray-500">
                            No parent clients available
                          </div>
                        ) : (
                          enterpriseList.map((enterprise) => (
                            <div
                              key={enterprise.id}
                              onClick={(e) => {
                                e.stopPropagation();
                                // Prefer parent currency from list `code` when API provides it.
                                const parentCurrency =
                                  enterprise.code ||
                                  enterprise.CurrencyCode ||
                                  enterprise.currencyCode ||
                                  "";
                                setFormData((prev) => ({
                                  ...prev,
                                  parentCompanyId: enterprise.id,
                                  parentCompanyName: enterprise.name,
                                  currencyCode: parentCurrency
                                    ? String(parentCurrency).toUpperCase()
                                    : Number(enterprise.id) ===
                                        Number(prev.parentCompanyId)
                                      ? prev.currencyCode
                                      : "",
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  parentClient: null,
                                }));
                                setIsParentClientOpen(false);
                              }}
                              className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                            >
                              {enterprise.name}
                            </div>
                          ))
                        )}
                      </div>
                    )}

                    <div className="min-h-[16px]">
                      {errors.parentClient && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.parentClient}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Code</label>

                <input
                  placeholder="Enter code"
                  className="w-full border rounded-md px-3 py-2 text-sm input-field"
                  value={isEditMode ? formData.clientCode : "--"}
                  disabled
                />
                <div className="flex justify-left mt-1">
                  <span className="text-xs text-black">
                    System generated code
                  </span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Name <span className="text-error">*</span>
                </label>
                <input
                  placeholder="Enter client name"
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.name ? "input-error" : ""
                  }`}
                  value={formData.name}
                  maxLength={100}
                  onChange={(e) => {
                    // Client name: allow only letters and spaces (no numbers, no special characters)
                    const sanitized = sanitizeName(e.target.value);
                    setFormData({
                      ...formData,
                      name: sanitized,
                    });

                    setErrors((prev) => ({
                      ...prev,
                      name: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.name && (
                    <p className="text-xs text-red-500 mt-1">{errors.name}</p>
                  )}
                </div>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Description
                </label>

                <textarea
                  rows={3}
                  maxLength={3000}
                  placeholder="Enter description"
                  className="w-full border rounded-md px-3 py-2 text-sm input-field resize-none"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      description: sanitizeInput(e.target.value, {
                        allowNumbers: true,
                        allowLetters: true,
                        allowSpaces: true,
                        allowPunctuation: true,
                      }),
                    })
                  }
                />

                <div className="flex justify-end mt-1">
                  <span className="text-xs text-black">
                    3000 characters max
                  </span>
                </div>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Office Address <span className="text-error">*</span>
                </label>
                <textarea
                  rows={3}
                  maxLength={3000}
                  placeholder="Enter office address"
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field h-20 resize-none ${
                    errors.address ? "input-error" : ""
                  }`}
                  value={formData.address}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      address: sanitizeInput(e.target.value, {
                        allowNumbers: true,
                        allowLetters: true,
                        allowSpaces: true,
                        allowPunctuation: true,
                      }),
                    });

                    setErrors((prev) => ({
                      ...prev,
                      address: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.address && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.address}
                    </p>
                  )}
                </div>
              </div>

              <div className="relative">
                <label className="block text-sm font-medium mb-1">
                  Country <span className="text-error">*</span>
                </label>

                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsCountryOpen((prev) => !prev);
                    setIsTimeZoneOpen(false);
                    setIsCurrencyOpen(false);
                    setIsClientTypeOpen(false);
                    setIsParentClientOpen(false);
                  }}
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                    errors.country ? "input-error" : ""
                  }`}
                >
                  <span
                    className={
                      formData.country ? "text-black" : "text-gray-400"
                    }
                  >
                    {formData.country || "- Select -"}
                  </span>
                  {isCountryOpen ? (
                    <FiChevronUp size={16} />
                  ) : (
                    <FiChevronDown size={16} />
                  )}
                </button>

                {/* {isCountryOpen && (
                <div
                  className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] min-h-[120px] overflow-y-auto
    menu-scrollbar"
                  onClick={(e) => e.stopPropagation()}
                >
                  {countryMaster.map((country) => (
                    <div
                      key={country}
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormData({ ...formData, country });
                        setIsCountryOpen(false);
                      }}
                      className="flex items-center gap-3
          px-4 py-2.5
          text-sm cursor-pointer
          border-b border-gray-200
          last:border-b-0"
                    >
                      {country.name}
                    </div>
                  ))}
                </div>
              )} */}

                {isCountryOpen && (
                  <div
                    className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] min-h-[120px] overflow-y-auto menu-scrollbar"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {countryMaster.map((country) => (
                      <div
                        key={country.id}
                        onClick={(e) => {
                          e.stopPropagation();
                          setFormData((prev) => ({
                            ...prev,
                            country: country.name,
                            countryId: country.id,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            country: "",
                          }));
                          setIsCountryOpen(false);
                        }}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                      >
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}

                <div className="min-h-[16px]">
                  {errors.country && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.country}
                    </p>
                  )}
                </div>
              </div>

              <div className="relative">
                <label className="block text-sm font-medium mb-1">
                  Timezone <span className="text-error">*</span>
                </label>
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsTimeZoneOpen((prev) => !prev);
                    setIsCountryOpen(false);
                    setIsCurrencyOpen(false);
                    setIsClientTypeOpen(false);
                    setIsParentClientOpen(false);
                  }}
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                    errors.timeZone ? "input-error" : ""
                  }`}
                >
                  <span
                    className={
                      formData.timeZoneName ? "text-black" : "text-gray-400"
                    }
                  >
                    {formData.timeZoneName || "- Select -"}
                  </span>
                  {isTimeZoneOpen ? (
                    <FiChevronUp size={16} />
                  ) : (
                    <FiChevronDown size={16} />
                  )}
                </button>
                {isTimeZoneOpen && (
                  <div
                    className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] min-h-[120px] overflow-y-auto menu-scrollbar"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {timeZoneMaster.map((tz) => (
                      <div
                        key={tz.id}
                        onClick={(e) => {
                          e.stopPropagation();
                          setFormData((prev) => ({
                            ...prev,
                            timeZoneName: tz.name || tz.code,                           
                            timeZoneId: tz.id,
                          }));
                          setErrors((prev) => ({ ...prev, timeZone: null }));
                          setIsTimeZoneOpen(false);
                        }}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                      >
                        {tz.name || tz.code}
                      </div>
                    ))}
                  </div>
                )}
                <div className="min-h-[16px]">
                  {errors.timeZone && (
                    <p className="text-xs text-red-500 mt-1">{errors.timeZone}</p>
                  )}
                </div>
              </div>

              {isSiteClientType() ? (
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Currency
                  </label>
                  <input
                    className="w-full border rounded-md px-3 py-2 text-sm input-field"
                    value={formData.currencyCode || "--"}
                    disabled
                    readOnly
                  />
                  <div className="min-h-[16px]" />
                </div>
              ) : (
                <div className="relative">
                  <label className="block text-sm font-medium mb-1">
                    Currency <span className="text-error">*</span>
                  </label>

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsCurrencyOpen((prev) => !prev);
                      setIsCountryOpen(false);
                      setIsTimeZoneOpen(false);
                      setIsClientTypeOpen(false);
                      setIsParentClientOpen(false);
                    }}
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                      errors.currency ? "input-error" : ""
                    }`}
                  >
                    <span
                      className={
                        formData.currencyCode ? "text-black" : "text-gray-400"
                      }
                    >
                      {formData.currencyCode || "- Select -"}
                    </span>
                    {isCurrencyOpen ? (
                      <FiChevronUp size={16} />
                    ) : (
                      <FiChevronDown size={16} />
                    )}
                  </button>

                  {isCurrencyOpen && (
                    <div
                      className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] min-h-[120px] overflow-y-auto menu-scrollbar"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {currencyMaster.map((currency) => {
                        const code = (
                          currency.code ||
                          currency.name ||
                          ""
                        ).toUpperCase();
                        return (
                          <div
                            key={currency.id || code}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormData((prev) => ({
                                ...prev,
                                currencyCode: code,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                currency: null,
                              }));
                              setIsCurrencyOpen(false);
                            }}
                            className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                          >
                            {code}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  <div className="min-h-[16px]">
                    {errors.currency && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.currency}
                      </p>
                    )}
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-1">
                  POC Name <span className="text-error">*</span>
                </label>
                <input
                  placeholder="Enter POC name"
                  maxLength={100}
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.pocName ? "input-error" : ""
                  }`}
                  value={formData.pocName}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      pocName: sanitizeInput(e.target.value),
                    });

                    setErrors((prev) => ({
                      ...prev,
                      pocName: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.pocName && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.pocName}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  POC Email <span className="text-error">*</span>
                </label>
                <input
                  placeholder="Enter POC email"
                  maxLength={100}
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.pocEmail ? "input-error" : ""
                  }`}
                  value={formData.pocEmail}
                  onChange={(e) => {
                    // Prevent @@ and .. patterns in email
                    const sanitized = sanitizeEmail(e.target.value);
                    setFormData({
                      ...formData,
                      pocEmail: sanitized,
                    });

                    setErrors((prev) => ({
                      ...prev,
                      pocEmail: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.pocEmail && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.pocEmail}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  POC Mobile Number <span className="text-error">*</span>
                </label>
                <input
                  placeholder="Enter POC mobile number"
                  type="inte"
                  maxLength={20}
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.pocMobile ? "input-error" : ""
                  }`}
                  value={formData.pocMobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFormData({ ...formData, pocMobile: value });

                    setErrors((prev) => ({
                      ...prev,
                      pocMobile: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.pocMobile && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.pocMobile}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-7">
            <h2 className="text-base font-semibold text-primary mb-4">
              Section 2: URL Branding
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="md:col-span-1">
                <label className="block text-sm font-medium mb-1">
                  URL Branding Name <span className="text-error">*</span>
                </label>

                <div
                  className={`flex items-center w-full border rounded-md overflow-hidden text-sm ${
                    errors.urlBrandingName ? "input-error" : ""
                  }`}
                >
                  <span className="px-3 text-gray-500">https://</span>

                  <input
                    type="text"
                    placeholder="globaltechsolutions"
                    maxLength={20}
                    className={`flex-1 px-3 py-2 outline-none text-sm ${
                      errors.urlBrandingName ? "input-error" : ""
                    }`}
                    value={formData.urlBrandingName}
                    // onChange={(e) => {
                    //   setFormData({
                    //     ...formData,
                    //     urlBrandingName: e.target.value,
                    //   });
                    onChange={(e) => {
                      // Allow alphanumeric characters, hyphens, and underscores
                      const sanitized = sanitizeBrandingName(e.target.value);
                      setFormData({
                        ...formData,
                        urlBrandingName: sanitized,
                      });

                      setErrors((prev) => ({
                        ...prev,
                        urlBrandingName: null,
                        loginImage: null,
                      }));
                    }}
                  />

                  <span className="px-3 text-primary">{BRANDING_DOMAIN}</span>
                </div>
                <div className="min-h-[16px]">
                  {errors.urlBrandingName && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.urlBrandingName}
                    </p>
                  )}
                </div>
              </div>

              <div className="hidden md:block"></div>

              <div className="md:col-span-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <ImageUploadCard
                    label="Login Page Image"
                    required
                    maxSizeMB={5}
                    error={errors.loginImage}
                    onFileSelect={(file) => {
                      if (!validateImageFile(file, "loginImage")) return;

                      setLoginBgImageFile(file);
                      setLoginBgImage(URL.createObjectURL(file)); // preview
                      setErrors((prev) => ({ ...prev, loginImage: "" }));
                    }}
                    initialPreview={loginBgImage}
                  />
                  <ImageUploadCard
                    label="Company Logo"
                    required
                    maxSizeMB={2}
                    error={errors.companyLogo}
                    onFileSelect={(file) => {
                      if (!validateImageFile(file, "companyLogo")) return;

                      setCompanyLogoFileObj(file);
                      setCompanyLogoFile(URL.createObjectURL(file)); // preview
                      setErrors((prev) => ({ ...prev, companyLogo: "" }));
                    }}
                    initialPreview={companyLogoFile}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-7">
            <h2 className="text-base font-semibold text-primary mb-3">
              Section 3: Licenses Management
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Number of Licenses <span className="text-error">*</span>
                </label>
                <input
                  placeholder="Enter number of licenses"
                  type="number"
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.numberOfLicenses ? "input-error" : ""
                  }`}
                  value={formData.numberOfLicenses}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      numberOfLicenses: e.target.value,
                    });

                    setErrors((prev) => ({
                      ...prev,
                      numberOfLicenses: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.numberOfLicenses && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.numberOfLicenses}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Licenses in use
                </label>
                <input
                  disabled
                  placeholder="Enter licenses in use"
                  type="number"
                  className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                    errors.licenseInUse ? "input-error" : ""
                  }`}
                  value={formData.licenseInUse}
                  onChange={(e) => {
                    setFormData({ ...formData, licenseInUse: e.target.value });

                    setErrors((prev) => ({
                      ...prev,
                      licenseInUse: null,
                    }));
                  }}
                />
                <div className="min-h-[16px]">
                  {errors.licenseInUse && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.licenseInUse}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Start Date <span className="text-error">*</span>
                </label>

                <div className="flex flex-col">
                  <div className="relative h-[40px]">
                    <input
                      ref={startDateRef}
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                      className={`
        w-full border rounded-md
        px-3 py-2 pr-10
        text-sm input-field input-field-date 
       ${errors.startDate ? "input-error" : ""}`}
                      value={formData.startDate}
                      onChange={(e) => {
                        setFormData({ ...formData, startDate: e.target.value });

                        setErrors((prev) => ({
                          ...prev,
                          startDate: null,
                        }));
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => startDateRef.current?.showPicker()}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-primary"
                    >
                      <FiCalendar size={18} />
                    </button>

                    <div className="min-h-[16px]">
                      {errors.startDate && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.startDate}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  End Date <span className="text-error">*</span>
                </label>

                <div className="flex flex-col">
                  <div className="relative h-[40px]">
                    <input
                      placeholder="End Date"
                      ref={endDateRef}
                      type="date"
                      min={
                        formData.startDate ||
                        new Date().toISOString().split("T")[0]
                      }
                      className={`w-full border rounded-md
        px-3 py-2 pr-10
        text-sm input-field input-field-date ${
          errors.endDate ? "input-error" : ""
        }`}
                      value={formData.endDate}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        const startDate = formData.startDate;

                        // Validate that end date is not before start date (only if start date is selected)
                        if (startDate && selectedDate < startDate) {
                          setErrors((prev) => ({
                            ...prev,
                            endDate: "End date must be after start date",
                          }));
                          return;
                        }

                        setFormData({ ...formData, endDate: selectedDate });

                        setErrors((prev) => ({
                          ...prev,
                          endDate: null,
                        }));
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => endDateRef.current?.showPicker()}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-primary"
                    >
                      <FiCalendar size={18} />
                    </button>
                    <div className="min-h-[16px]">
                      {errors.endDate && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.endDate}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-7">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-base font-semibold text-primary">
                Section 4: System Users
              </h2>

              <div
                className="flex items-center text-primary text-sm gap-1 cursor-pointer"
                onClick={handleAddUser}
              >
                <FiPlusCircle size={18} /> Add User
              </div>
            </div>

            {systemUsers.map((user, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.5fr_1fr_auto] gap-4 items-start mb-4"
              >
                <div>
                  <label className="block text-sm font-medium mb-1">
                    First Name <span className="text-error">*</span>
                  </label>

                  <input
                    placeholder="Enter first name"
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                      systemUserErrors[index]?.firstName ? "input-error" : ""
                    } `}
                    value={user.firstName}
                    // onChange={(e) => {
                    //   const updated = [...systemUsers];
                    //   updated[index].firstName = e.target.value;
                    //   setSystemUsers(updated);

                    // }}

                    onChange={(e) => {
                      // Only allow letters and spaces (no numbers, no special characters)
                      const sanitized = sanitizeName(e.target.value);
                      const updatedUsers = [...systemUsers];
                      updatedUsers[index].firstName = sanitized;
                      setSystemUsers(updatedUsers);

                      const updatedErrors = [...systemUserErrors];
                      if (updatedErrors[index]) {
                        updatedErrors[index] = {
                          ...updatedErrors[index],
                          firstName: "",
                        };
                      }
                      setSystemUserErrors(updatedErrors);
                    }}
                  />
                  <div className="min-h-[16px]">
                    {systemUserErrors[index]?.firstName && (
                      <p className="text-xs text-red-500 mt-1">
                        {systemUserErrors[index].firstName}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Last Name <span className="text-error">*</span>
                  </label>
                  <input
                    placeholder="Enter last name"
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                      systemUserErrors[index]?.lastName ? "input-error" : ""
                    } `}
                    value={user.lastName}
                    onChange={(e) => {
                      // Only allow letters and spaces (no numbers, no special characters)
                      const sanitized = sanitizeName(e.target.value);
                      const updatedUsers = [...systemUsers];
                      updatedUsers[index].lastName = sanitized;
                      setSystemUsers(updatedUsers);

                      const updatedErrors = [...systemUserErrors];
                      if (updatedErrors[index]) {
                        updatedErrors[index] = {
                          ...updatedErrors[index],
                          lastName: "",
                        };
                      }
                      setSystemUserErrors(updatedErrors);
                    }}
                  />
                  <div className="min-h-[16px]">
                    {systemUserErrors[index]?.lastName && (
                      <p className="text-xs text-red-500 mt-1">
                        {systemUserErrors[index].lastName}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Email Id <span className="text-error">*</span>
                  </label>
                  <input
                    placeholder="Enter email id (@planetngtech.com)"
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                      systemUserErrors[index]?.emailId ? "input-error" : ""
                    } `}
                    value={user.emailId}
                    onChange={(e) => {
                      // Prevent @@ and .. patterns in email
                      const sanitized = sanitizeEmail(e.target.value);
                      const updatedUsers = [...systemUsers];
                      updatedUsers[index].emailId = sanitized;
                      setSystemUsers(updatedUsers);

                      const updatedErrors = [...systemUserErrors];
                      if (updatedErrors[index]) {
                        updatedErrors[index] = {
                          ...updatedErrors[index],
                          emailId: "",
                        };
                      }
                      setSystemUserErrors(updatedErrors);
                    }}
                  />
                  <div className="min-h-[16px]">
                    {systemUserErrors[index]?.emailId && (
                      <p className="text-xs text-red-500 mt-1">
                        {systemUserErrors[index].emailId}
                      </p>
                    )}
                  </div>
                </div>

                {/* <div>
                  <label className="block text-sm font-medium mb-1">
                    User Type <span className="text-error">*</span>
                  </label>
                  <input
                    placeholder="Enter role"
                    className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                      systemUserErrors[index]?.role ? "input-error" : ""
                    } `}
                    value={user.role}
                    onChange={(e) => {
                      const updatedUsers = [...systemUsers];
                      updatedUsers[index].role = e.target.value;
                      setSystemUsers(updatedUsers);

                      const updatedErrors = [...systemUserErrors];
                      if (updatedErrors[index]) {
                        updatedErrors[index] = {
                          ...updatedErrors[index],
                          role: "",
                        };
                      }
                      setSystemUserErrors(updatedErrors);
                    }}
                  />
                  <div className="min-h-[16px]">
                    {systemUserErrors[index]?.role && (
                      <p className="text-xs text-red-500 mt-1">
                        {systemUserErrors[index].role}
                      </p>
                    )}
                  </div>
                </div> */}

                <div>
                  <div className="relative">
                    <label className="block text-sm font-medium mb-1">
                      Roles <span className="text-error">*</span>
                    </label>

                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        // Toggle this specific user's dropdown
                        setOpenUserTypeIndex(
                          openUserTypeIndex === index ? null : index,
                        );
                      }}
                      className={`w-full border rounded-md px-3 py-2 text-sm input-field flex justify-between items-center ${
                        systemUserErrors[index]?.role ? "input-error" : ""
                      }`}
                    >
                      <span
                        className={
                          systemUsers[index].role
                            ? "text-black"
                            : "text-gray-400"
                        }
                      >
                        {systemUsers[index].role || "- Select -"}
                      </span>

                      {openUserTypeIndex === index ? (
                        <FiChevronUp size={16} />
                      ) : (
                        <FiChevronDown size={16} />
                      )}
                    </button>

                    {openUserTypeIndex === index && (
                      <div
                        className="absolute z-20 top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden max-h-[200px] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                        }}
                      >
                        {systemRoleMaster.map((role) => (
                          <div
                            key={role.id}
                            onClick={(e) => {
                              e.stopPropagation();

                              // update user's default role (system role)
                              const updatedUsers = [...systemUsers];
                              updatedUsers[index].role = role.name;
                              updatedUsers[index].DefaultRoleId = role.id;
                              
                              setSystemUsers(updatedUsers);

                              // clear role error
                              const updatedErrors = [...systemUserErrors];
                              if (updatedErrors[index]) {
                                updatedErrors[index] = {
                                  ...updatedErrors[index],
                                  role: "",
                                };
                              }
                              setSystemUserErrors(updatedErrors);

                              setOpenUserTypeIndex(null);
                            }}
                            className="px-4 py-2.5 text-sm cursor-pointer border-b border-gray-200 last:border-b-0 hover:bg-gray-100"
                          >
                            {role.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="min-h-[16px]">
                    {systemUserErrors[index]?.role && (
                      <p className="text-xs text-red-500 mt-1">
                        {systemUserErrors[index].role}
                      </p>
                    )}
                  </div>
                </div>
                {/* Remove User Button — any row when more than one user remains */}
                {systemUsers.length > 1 && (
                  <div className="flex items-center justify-center h-[40px] mt-[22px]">
                    <button
                      type="button"
                      onClick={() => handleRemoveUserClick(index)}
                      className="flex items-center justify-center text-primary hover:text-red-500 transition-colors cursor-pointer"
                      title="Remove user"
                    >
                      <FiX size={20} />
                    </button>
                  </div>
                )}

                {/* <div className="flex flex-col">
                  <div className="flex items-center justify-center h-[40px] mt-[22px]">
                    <button className="focus:outline-none">
                      <BsToggleOn size={28} color="#163D68" />
                    </button>
                  </div>
                </div> */}
              </div>
            ))}
          </div>

          <div className="">
          <h2 className="text-base font-semibold text-primary mb-3">
            Section 5: Roles Mapping
          </h2>
         

          <div className="grid lg:grid-cols-3 md:grid-cols-3 gap-4">
            {/* System Roles: dropdown clickable; all checked, checkboxes disabled so cannot uncheck */}
            <div>
              <MultiSelectDropdown
                label="System Roles"
                required
                options={systemRoleMaster.map((r) => r.name)}
                value={systemRoleMaster.map((r) => r.name)}
                readOnly={true}
              />
            </div>

            {/* Standard Roles: all checked by default, can uncheck via dropdown */}
            <div>
              <MultiSelectDropdown
                label="Standard Roles"
                options={standardRoleMaster.map((r) => r.name)}
                value={(formData.standardRoleIds || [])
                  .map((id) => standardRoleMaster.find((r) => r.id === id)?.name)
                  .filter(Boolean)}
                onChange={(selectedNames) => {
                  const newIds = selectedNames
                    .map((name) => standardRoleMaster.find((r) => r.name === name)?.id)
                    .filter((id) => id != null);
                  setFormData((prev) => ({ ...prev, standardRoleIds: newIds }));
                  setErrors((prev) => ({ ...prev, roleMapping: null }));
                }}
              />
            </div>

            {/* Custom Roles: none checked by default */}
            <div>
              <MultiSelectDropdown
                label="Custom Roles"
                options={customRoleMaster.map((r) => r.name)}
                value={(formData.customRoleIds || [])
                  .map((id) => customRoleMaster.find((r) => r.id === id)?.name)
                  .filter(Boolean)}
                onChange={(selectedNames) => {
                  const newIds = selectedNames
                    .map((name) => customRoleMaster.find((r) => r.name === name)?.id)
                    .filter((id) => id != null);
                  setFormData((prev) => ({ ...prev, customRoleIds: newIds }));
                  setErrors((prev) => ({ ...prev, roleMapping: null }));
                }}
              />
            </div>
          </div>
          <div className="min-h-[16px] mt-1">
            {errors.roleMapping && (
              <p className="text-xs text-red-500">{errors.roleMapping}</p>
            )}
          </div>
        </div> 

        <div className="mb-7">
          <h2 className="text-base font-semibold text-primary mb-3">
            Section 6: Other Settings
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Number of sessions allowed per user <span className="text-error">*</span>
              </label>
              <input
                type="number"
                min={1}
                max={99}
                inputMode="numeric"
                placeholder="Enter number"
                className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                  errors.maxUserSessions ? "input-error" : ""
                }`}
                value={formData.maxUserSessions}
                onChange={(e) => {
                  const rawValue = e.target.value;

                  if (rawValue === "") {
                    setFormData((prev) => ({ ...prev, maxUserSessions: "" }));
                  } else {
                    const digitsOnly = rawValue.replace(/\D/g, "").slice(0, 2);
                    setFormData((prev) => ({
                      ...prev,
                      maxUserSessions:
                        digitsOnly === "" ? "" : Number(digitsOnly),
                    }));
                  }

                  setErrors((prev) => ({
                    ...prev,
                    maxUserSessions: null,
                  }));
                }}
              />
              <div className="min-h-[16px]">
                {errors.maxUserSessions && (
                  <p className="text-xs text-red-500 mt-1">
                    {errors.maxUserSessions}
                  </p>
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Session Timeout <span className="text-error">*</span>
              </label>
              <select
                className={`w-full border rounded-md px-3 py-2 text-sm input-field ${
                  errors.sessionTimeout ? "input-error" : ""
                }`}
                value={formData.sessionTimeout}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    sessionTimeout: Number(e.target.value),
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    sessionTimeout: null,
                  }));
                }}
              >
                <option value={20}>20 minutes</option>
                <option value={30}>30 minutes</option>
                <option value={60}>60 minutes</option>
                <option value={120}>120 minutes</option>
                <option value={0}>Infinite</option>
              </select>
              <div className="min-h-[16px]">
                {errors.sessionTimeout && (
                  <p className="text-xs text-red-500 mt-1">
                    {errors.sessionTimeout}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        </div>

        {/* <GenericModal
          open={showSaveModal}
          title={isEditMode ? "Update Client" : "Save Client"}
          description="Are you sure you want to save the client details?"
          primaryText={isEditMode ? "Update" : "Save"}
          secondaryText="Cancel"
          loading={saving}
          onClose={() => setShowSaveModal(false)}
          onPrimary={async () => {
            setSaving(true);

            // simulate API call
            setTimeout(() => {
              setSaving(false);
              setShowSaveModal(false);
              navigate("/clients");
            }, 1200);
          }}
        /> */}

        <GenericModal
          open={showSaveModal}
          title={isEditMode ? "Update Client" : "Save Client"}
          description="Are you sure you want to save the client details?"
          primaryText={isEditMode ? "Update" : "Save"}
          secondaryText="Cancel"
          loading={saving}
          onClose={() => {
            setShowSaveModal(false);
            setSaving(false);
          }}
          onPrimary={async () => {
            await submitClient();
          }}
        />

        <div className="flex justify-end lg:mt-5 md:mt-4">
          <div className="flex gap-3">
            <button
              className="text-sm text-black w-[120px]"
              onClick={() => setShowCancelModal(true)}
            >
              Cancel
            </button>

            <button
              className="btn-save w-[120px]"
              onClick={() => {
                if (!validateForm()) return;
                setShowSaveModal(true);
              }}
            >
              {isEditMode ? "Update" : "Save"}
            </button>
          </div>
        </div>

        {/* Cancel Confirmation Modal */}
        <GenericModal
          open={showCancelModal}
          title="Confirm Cancel"
          description="Are you sure you want to cancel and exit? All unsaved changes will be lost."
          primaryText="Yes"
          secondaryText="No"
          type="warning"
          onPrimary={() => {
            setShowCancelModal(false);
            navigate("/clients");
          }}
          onClose={() => setShowCancelModal(false)}
        />

        {/* Remove User Confirmation Modal */}
        <GenericModal
          open={showRemoveUserModal}
          title="Remove User"
          description="Are you sure you want to remove this user? Saved users will be deactivated in PXP when you save the client. At least one system user must remain."
          primaryText="Yes"
          secondaryText="No"
          type="warning"
          onPrimary={confirmRemoveUser}
          onClose={() => {
            setShowRemoveUserModal(false);
            setUserToRemoveIndex(null);
          }}
        />

        {/* Success/Error Modal */}
        <GenericModal
          open={modalState.open}
          title={modalState.title}
          description={modalState.description}
          type={modalState.type}
          primaryText="OK"
          onPrimary={() => {
            const wasSuccess = modalState.type === "success";
            setModalState((prev) => ({ ...prev, open: false }));
            if (wasSuccess) {
              navigate("/clients");
            }
          }}
          onClose={() => {
            const wasSuccess = modalState.type === "success";
            setModalState((prev) => ({ ...prev, open: false }));
            if (wasSuccess) {
              navigate("/clients");
            }
          }}
        />
      </div>
    </>
  );
};

export default ClientForm;
